import { getMessageMinimumDetails } from 'Api/beMessApi'
import { getRecipient } from 'Api/beRecipientApi'
import {
  getRecipientDailyCounters,
  getRecipientEventsOpenings,
  getRecipientMessagesTotalCounters,
} from 'Api/beStatisticsApi'
import {
  STORE_KEY_ID_LIST,
  STORE_KEY_LIST,
  storeGet,
} from 'mailup-react-helpers'

import { toLocalDate } from 'mailup-react-helpers'

export async function getMessageMinimumDetailsAction(idMessage) {
  const resp = await getMessageMinimumDetails(idMessage)
  return resp
}

export async function getRecipientAction(idRecipient) {
  const resp = await getRecipient(idRecipient)
  return resp
}

export async function getRecipientEventsOpeningsAction(
  idRecipient,
  pagesize,
  pagenumber,
  orderby,
  orderdescending,
) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const resp = await getRecipientEventsOpenings(
    idList,
    idRecipient,
    pagesize,
    pagenumber,
    orderby,
    orderdescending,
  )

  return resp
}

export async function getRecipientMessagesTotalCountersAction(
  idRecipient,
  pagesize,
  pagenumber,
  orderby,
  orderdescending,
  types,
) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const resp = await getRecipientMessagesTotalCounters(
    idList,
    idRecipient,
    pagesize,
    pagenumber,
    orderby,
    orderdescending,
    types,
  )

  return resp
}

export async function getChartDataAction(idRecipient, from, to, types) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)
  const resp = await getRecipientDailyCounters(
    idList,
    idRecipient,
    from,
    to,
    TimeZoneCode,
    types,
  )

  const counters = resp.Counters.DailyCounters.map((o) => ({
    ...o,
    DateHour: setDateUTCtoCtz(o.DateHour, TimeZoneCode),
  }))
  let x = []
  if (counters.length > 0) {
    x = addMissingDatePoints(
      counters,
      setDateUTCtoCtz(counters[0].DateHour, TimeZoneCode),
      setDateUTCtoCtz(counters[counters.length - 1].DateHour, TimeZoneCode),
    )
  }
  const ret = x.map(({ DateHour, TotalCounters: { AT, CT } }) => [
    DateHour,
    AT,
    CT,
  ])

  return ret
}

function setDateUTCtoCtz(dateString, TimeZoneCode) {
  const dateInstance = new Date(dateString)
  return dateString
    ? toLocal(
        new Date(
          dateInstance.getTime() + dateInstance.getTimezoneOffset() * 60000,
        ),
        0,
        TimeZoneCode,
      )
    : ''
}

function toLocal(date, withOffset = 0, TimeZoneCode) {
  const dateWithOffset = new Date(date.getTime() - withOffset)

  return toLocalDate(dateWithOffset, TimeZoneCode)
}

function addMissingDatePoints(data, dateFrom, dateTo) {
  const ret = []

  var dates = getDates(dateFrom, dateTo)
  dates.forEach((d) => {
    const compareDate = d.setHours(0, 0, 0, 0)
    const item = data.find(
      (item) => compareDate === item.DateHour.setHours(0, 0, 0, 0),
    )

    item !== undefined
      ? ret.push(item)
      : ret.push({ DateHour: d, TotalCounters: { AT: 0, CT: 0 } })
  })

  return ret
}

var getDates = (startDate, endDate) => {
  var dates = []
  var currentDate = startDate
  var addDays = function (days) {
    var date = new Date(this.valueOf())
    date.setDate(date.getDate() + days)
    return date
  }
  while (currentDate <= endDate) {
    dates.push(currentDate)
    currentDate = addDays.call(currentDate, 1)
  }
  return dates
}
